export default __webpack_public_path__ + "static/media/audioIcon2.138092e0.svg";